import BaseApi from '../BaseApi';
import { TreeApiConverter } from './TreeApiConverter';

class TreeApi extends BaseApi {
  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}`;
    this.converter = new TreeApiConverter();
  }

  changeUserStateByAction = ({ id, value, name }) =>
    this.sendQuery(this.queryTypes.POST, `${this.baseUrl}/balance_tree`, {
      action: name,
      state: value,
      target_user: id,
    });

  getUsersByUserId = ({ id, isClickedByButton, targetName }) =>
    this.sendQuery(this.queryTypes.GET, `/api/agent_admin/user/${id}/tree/`, null, null, data =>
      this.converter.convertUsersById({ data, id, isClickedByButton, targetName }),
    );
}

export default TreeApi;
